import { render, staticRenderFns } from "./UserServices.vue?vue&type=template&id=f1bd3f94&scoped=true"
import script from "./UserServices.vue?vue&type=script&lang=ts"
export * from "./UserServices.vue?vue&type=script&lang=ts"
import style0 from "./UserServices.vue?vue&type=style&index=0&id=f1bd3f94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1bd3f94",
  null
  
)

export default component.exports